import { create } from 'zustand';
import type {
  GeneralBalanceData,
  AccontTypeData,
  RegularAccount,
  MarginAccount,
} from './types';

interface AccountsStore {
  accountsQty: number;
  general: GeneralBalanceData | null;
  ewallet: AccontTypeData<RegularAccount> | null;
  spot: AccontTypeData<RegularAccount> | null;
  invest: AccontTypeData<MarginAccount> | null;
  leverage: AccontTypeData<MarginAccount> | null;
  earn: AccontTypeData<MarginAccount> | null;
  setAccountsQty: (accountsQty: number) => void;
  setGeneral: (general: GeneralBalanceData) => void;
  setEwallet: (ewallet: AccontTypeData<RegularAccount>) => void;
  setSpot: (spot: AccontTypeData<RegularAccount>) => void;
  setInvest: (invest: AccontTypeData<MarginAccount>) => void;
  setLeverage: (leverage: AccontTypeData<MarginAccount>) => void;
  setEarn: (earn: AccontTypeData<MarginAccount>) => void;
}

const useAccountsStore = create<AccountsStore>(set => ({
  accountsQty: 0,
  general: null,
  spot: null,
  ewallet: null,
  invest: null,
  leverage: null,
  earn: null,
  setAccountsQty: (accountsQty: number) => set({ accountsQty }),
  setGeneral: (general: GeneralBalanceData) => set({ general }),
  setEwallet: (ewallet: AccontTypeData<RegularAccount>) => set({ ewallet }),
  setSpot: (spot: AccontTypeData<RegularAccount>) => set({ spot }),
  setInvest: (invest: AccontTypeData<MarginAccount>) => set({ invest }),
  setLeverage: (leverage: AccontTypeData<MarginAccount>) => set({ leverage }),
  setEarn: (earn: AccontTypeData<MarginAccount>) => set({ earn }),
}));

export { useAccountsStore };
